import React, { Component } from "react"
import { Button, ButtonToolbar } from "react-bootstrap"
import { BootstrapTable } from "react-bootstrap-table"
import { LoanGroupEnum, LoanStatus } from "../../lib/utils"
import AssignToForm from "./AssignToForm"
import Authenticated from "../../lib/Authenticated"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import UpdateLoanGroupForm from "./UpdateLoanGroupForm"

class LoanTable extends Component {

  authenticated = new Authenticated()
  isApprover = this.authenticated.isApprover()
  isUnderwriter = this.authenticated.isUnderwriter()
  isAdmin = this.authenticated.isAdmin()
  isAccountant = this.authenticated.isAccountant()
  canExportData = this.isAdmin || this.isAccountant

  constructor(props) {
    super(props)

    this.state = {
      itemSelected: false,
      selectedLoans: [],
      selectRowProp: {
        mode: 'checkbox',
        clickToSelect: true,
        bgColor: '#9bbfdd',
        columnWidth: '48px',
        onSelectAll: (isSelected, rows) => this.addToLoansSelection(rows, isSelected),
        onSelect: (row, isSelected) => this.addToLoansSelection([row], isSelected),
      }
    }

    this.loanTableRef = null 
    this.setLoanTableRef = elt => {
      this.loanTableRef = elt
    }
  }

  addToLoansSelection = (loans, isSelected) => {

    let { selectedLoans } = this.state
    if(loans && loans.length) {
      if (isSelected) {
        selectedLoans.push(...loans)
      }
      else {
        selectedLoans = selectedLoans.filter(item => loans.findIndex(value => value.id === item.id) === -1)
      }
    }

    const nbItems = selectedLoans.length
    if (nbItems === 1) {
      this.props.selectedHandler(selectedLoans[0].id)
    }

    this.setState({ selectedLoans, itemSelected: nbItems > 0 })
  }

  isSameStatus = selectedLoans => selectedLoans.findIndex(first => selectedLoans
    .findIndex(second => second.status !== first.status) > -1) === -1

  isAllCompleted = selectedLoans => selectedLoans.every(item => item.status === LoanStatus.COMPLETED)

  isSameGroup = selectedLoans => selectedLoans.findIndex(first => 
    selectedLoans.findIndex(second => {
      const firstGroup = first.group ? first.group : LoanGroupEnum.NONE,
      secondGroup = second.group ? second.group : LoanGroupEnum.NONE
      return firstGroup !== secondGroup
    }) > -1) === -1

  getFirstStatus = selectedLoans => selectedLoans.length ? selectedLoans[0].status : ''

  canUserSeeToolbar = () => this.isApprover || this.isUnderwriter || this.isAdmin

  canUserAssignTo = (itemSelected, status, sameStatus) => 
    this.isAdmin && itemSelected && sameStatus
    && (status === LoanStatus.UNDERWRITER_REVIEW
    || status === LoanStatus.APPROVER_REVIEW
    || status === LoanStatus.UNDERWRITER_DECLINED
    || status === LoanStatus.DECLINED
    || status === LoanStatus.APPROVED
    || status === LoanStatus.COMPLETED)

  canUserAssignMe = (itemSelected, status, sameStatus) => 
    itemSelected  && sameStatus && 
      (status === LoanStatus.NEW || status === LoanStatus.UNDERWRITER_APPROVED)

  canUserApprove = (itemSelected, status, sameStatus) => 
    itemSelected && sameStatus &&
      (status === LoanStatus.APPROVER_REVIEW || status === LoanStatus.UNDERWRITER_REVIEW)

  canUserDecline = (itemSelected, status, sameStatus) =>
    itemSelected && sameStatus &&
      (status === LoanStatus.APPROVER_REVIEW || status === LoanStatus.UNDERWRITER_REVIEW)

  canChangeGroup = (itemSelected, allCompleted, sameGroup) => 
    this.isAdmin && itemSelected && allCompleted && sameGroup

  assignLoanClick = selectedLoans => {

    const status = this.getFirstStatus(selectedLoans),
      newStatus = (this.isAdmin && status === LoanStatus.NEW) || this.isUnderwriter 
      ? LoanStatus.UNDERWRITER_REVIEW : LoanStatus.APPROVER_REVIEW

    selectedLoans.forEach(loan => this.props.changeStatusClick(loan.id, newStatus))
    this.resetRowState()
  }

  approveLoanClick = selectedLoans => {

    const status = this.getFirstStatus(selectedLoans),
      newStatus = (this.isAdmin && status === LoanStatus.UNDERWRITER_REVIEW) || this.isUnderwriter 
      ? LoanStatus.UNDERWRITER_APPROVED : LoanStatus.APPROVED

    selectedLoans.forEach(loan => this.props.changeStatusClick(loan.id, newStatus))
    this.resetRowState()
  }

  declineLoanClick = selectedLoans => {

    const status = this.getFirstStatus(selectedLoans),
      newStatus = (this.isAdmin && status === LoanStatus.UNDERWRITER_REVIEW) || this.isUnderwriter 
      ? LoanStatus.UNDERWRITER_DECLINED : LoanStatus.DECLINED

    selectedLoans.forEach(loan => this.props.changeStatusClick(loan.id, newStatus))
    this.resetRowState()
  }

  resetRowState = () => {

    this.setState({
      selectedLoans: [],
      itemSelected: false,
    })

    if (this.loanTableRef) {
      this.loanTableRef.cleanSelected()
    }
  }

  renderToolbar = () => {

    if(!this.canUserSeeToolbar()) return null

    const { itemSelected, selectedLoans } = this.state,
      status = this.getFirstStatus(selectedLoans),
      sameStatus = this.isSameStatus(selectedLoans),
      sameGroup = this.isSameGroup(selectedLoans),
      allCompleted = this.isAllCompleted(selectedLoans)

    return (
      <ButtonToolbar className="margin-bottom-40">

        <Button bsStyle="primary" className="min-w-120"
          onClick={() => this.assignLoanClick(selectedLoans)}
          disabled={ !this.canUserAssignMe(itemSelected, status, sameStatus) }>
          Assign to Me
        </Button>

        <Button bsStyle="success" className="min-w-120"
          onClick={() => this.approveLoanClick(selectedLoans)}
          disabled={ !this.canUserApprove(itemSelected, status, sameStatus) }>
          Approve
        </Button>

        <Button bsStyle="danger" className="min-w-120"
          onClick={() => this.declineLoanClick(selectedLoans)}
          disabled={ !this.canUserDecline(itemSelected, status, sameStatus) }>
          Decline
        </Button>&nbsp;

        { !!this.canUserAssignTo(itemSelected, status, sameStatus) &&
          <span className="ml-10">
            <span>Assign To</span>{' '}
            <AssignToForm
              selectedLoans={ selectedLoans }
              callback={ this.resetRowState }
              loanStatus={ status }
              nbItems={ selectedLoans.length }
            />
          </span>
        }

        { !!this.canChangeGroup(itemSelected, allCompleted, sameGroup) &&
          <span className="ml-15">
            <span>Update group</span>{' '}
            <UpdateLoanGroupForm
              selectedLoans={ selectedLoans }
              callback={ this.resetRowState }
              nbItems={ selectedLoans.length }
            />
          </span>
        }
      </ButtonToolbar>
    )
  }

  renderContent() {

    const { items, children, dataTotalSize, sizePerPage, onPageChange,
      page, onSizePerPageList, onFilterChange, onSortChange } = this.props,
    { selectRowProp } = this.state

    return (
      <div>
        <BootstrapTable
          data={ items }
          remote
          pagination
          fetchInfo={{ dataTotalSize }}
          striped
          hover
          condensed
          selectRow={ selectRowProp }
          options={{
            sizePerPage,
            onPageChange,
            page,
            onSizePerPageList,
            onFilterChange,
            onSortChange
          }}
          className="loan-table"
          exportCSV={ this.canExportData }
          csvFileName='Loans.csv'
          ref={ this.setLoanTableRef }>
          { children }
        </BootstrapTable>
        { this.renderToolbar() }
      </div>
    )
  }

  render() {
    return (
      this.props.loading ? <p>Loading...</p> : this.renderContent()
    )
  }
}

export default LoanTable



// WEBPACK FOOTER //
// ./src/components/Loans/LoanTable.js